import { widerThanShell } from '@/lib/layout'

export const CLIENT_TABS = [
  { slug: 'overview', label: 'Overview' },
  { slug: 'linear-tickets', label: 'Linear Tickets' },
  { slug: 'meetings', label: 'Meetings and Emails' },
  { slug: 'helpdesk-health', label: 'HelpDesk Health' },
  { slug: 'client-tracker', label: 'Client Tracker' },
  { slug: 'contract-sla', label: 'Contract & SLA' },
  { slug: 'kpis', label: 'KPIs' },
  { slug: 'not-logged', label: 'Not logged' },
  { slug: 'settings', label: 'Settings' },
] as const

export const clientTabPath = (companyId: string, slug: string) => `/clients/${companyId}/${slug}`

// One request for the tab count and the Overview card: identical params share the query cache.
export const openTrackerParams = (companyId: string) => ({ companyId, limit: 100, closed: 'exclude' })

export const CLIENTS_PAGE = widerThanShell(1400, '4rem')
